<script lang="ts">
    import { tooltip } from "../../helper"
    import { login, carts } from "../../store"
    import { mdiCart, mdiCartOutline } from "@mdi/js"
    import Icon from "./Icon.svelte"
    import { _ } from "svelte-i18n"
    import AssignOperationToCart from "../routes/Carts/AssignOperationToCart.svelte"
    import { checkWheterOperationIsInCart } from "../../functions/cart/CartIcon"

    export let label: string = ""
    export let operation: Operation | OperationOut
    export let details = false
    export let clicked = false

    let showModal: boolean = false
    let isInCart: boolean = false
    async function setOpInCart(operation: Operation | OperationOut) {
        isInCart = await checkWheterOperationIsInCart(operation, $carts)
    }
    setOpInCart(operation)
    let tooltipContent: string | null = null
    let assignedToCarts = []

    const onIconClick = async () => {
        showModal = true
        clicked = false
    }
    $: if (operation || $carts) {
        let foundInCarts = ""

        if ($carts && $carts.length) {
            for (let cart of $carts) {
                for (let op of cart.operations) {
                    if (op.id === operation.id) {
                        if (
                            op.positions.every((position, index) => {
                                const otherPosition = operation.positions[index]
                                return position?.orderQuantity === otherPosition?.orderQuantity
                            })
                        ) {
                            assignedToCarts.push(cart.id)
                            foundInCarts += `<div><strong>${cart.name}</strong></div>`
                            break
                        }
                    }
                }
            }
        }

        if (isInCart && tooltipContent)
            tooltipContent = $_("cart.cartIcon.inCartTooltip", {
                values: {
                    foundInCarts: foundInCarts,
                },
            })
        else
            tooltipContent = details
                ? $_("cart.cartIcon.addMarkedItemsTooltip")
                : $_("cart.cartIcon.addAllItemsTooltip")
    }

    $: {
        if (clicked) onIconClick()
    }
    // das n test
</script>

{#if $login?.account.roles?.includes("A") || $login?.account?.permissions?.includes("B")}
    {#key isInCart}
        <!-- svelte-ignore a11y-no-static-element-interactions -->
        <div
            use:tooltip="{{ content: tooltipContent }}"
            class="cart-icon"
            on:click|stopPropagation="{onIconClick}"
            on:keydown
        >
            <Icon size="24px" path="{isInCart ? mdiCart : mdiCartOutline}" />
            {#if label}
                <span class="label">{label}</span>
            {/if}
        </div>
    {/key}
{/if}
{#key showModal}
    <AssignOperationToCart
        bind:show="{showModal}"
        {operation}
        title="{tooltipContent}"
        submitButtonLabel="{$_('general.add')}"
        on:update="{() => {
            setOpInCart(operation)
        }}"
    />{/key}
